import {
  UseQueryResult,
  createQueryStore,
  useQueries,
} from '@ferreri/minato-react-utils';
import { useCategoriesList } from '../categories/categories.store';
import { getCategoryImages } from './category-images.client';
import { CategoryImages } from './category-images.types';

export const useCategoryImages = () => {
  const { data: categories } = useCategoriesList();
  const queries = useQueries({
    queries: (categories || []).map((category) => {
      return {
        queryKey: ['category', category?.id, 'images'],
        queryFn: () => getCategoryImages(category?.id as string),
        enabled: !!category?.id,
        onError: () => null,
      };
    }),
  }).filter(
    (query) => query.status === 'success',
  ) as UseQueryResult<CategoryImages>[];

  const isLoading = queries.some((query) => query.isLoading);
  const categoryImages = queries.map((query) => query.data);

  return { data: categoryImages, isLoading };
};

export const useCurrentCategoryImage = (categoryId: string) => {
  return createQueryStore({
    queryKey: ['category_images', categoryId],
    queryFn: () => getCategoryImages(categoryId),
  });
};
